import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { ReleaseCoverImagePlayButton } from '@components/basics/ReleaseCoverImagePlayButton';
import type {
  FeedPostModalMainSoundFragment,
  FragmentType,
  ReleaseCoverImagePlayButtonFragmentDoc,
} from '@graphql/reactQuery';
import { FeedPostModalMainSoundFragmentDoc } from '@graphql/reactQuery';
import { FeedPostModalSoundSelectItemFragmentDoc, getFragment } from '@graphql/reactQuery';
import { SelectResourceUI } from './SelectResourceUI';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment FeedPostModalSoundSelectItem on Release {
    id
    track {
      id
      title
    }
    title
    artist {
      id
      name
    }
  }
`);

export function SoundSelectItem({
  releaseFrag,
  selected,
  onReleaseSelected,
}: {
  releaseFrag: FragmentType<FeedPostModalSoundSelectItemFragmentDoc> &
    FragmentType<ReleaseCoverImagePlayButtonFragmentDoc> &
    FragmentType<FeedPostModalMainSoundFragmentDoc>;
  selected: boolean;
  onReleaseSelected: (release: FeedPostModalMainSoundFragment) => void;
}) {
  const release = getFragment(FeedPostModalSoundSelectItemFragmentDoc, releaseFrag);

  return (
    <SelectResourceUI
      cover={
        <ReleaseCoverImagePlayButton
          playButtonSize="sm"
          nextImageSizes="48px"
          releaseFrag={releaseFrag}
        />
      }
      onClick={() => {
        onReleaseSelected(getFragment(FeedPostModalMainSoundFragmentDoc, releaseFrag));
      }}
      title={release.title}
      name={release.artist.name}
      selected={selected}
    />
  );
}
